var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { COLORS, BORDER_RADIUS, GRID, PADDING } from '../../Assets/styles/constants';
import { Button } from '@trustpilot/businessapp-patternlibrary';
import { StyleSheet, css } from 'aphrodite';
import { Cross } from '../../Assets/images';
var footerStyles = function () {
    return {
        display: 'flex',
        background: COLORS.grays.background,
        borderTop: "solid 1px " + COLORS.grays.cardBorder,
        borderBottomLeftRadius: BORDER_RADIUS.large,
        borderBottomRightRadius: BORDER_RADIUS.large,
        padding: GRID.small + " " + GRID.large,
        justifyContent: 'flex-end',
    };
};
var Modal = (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEscape = function (e) {
            if (e.keyCode === 27) {
                _this.props.onClose();
            }
        };
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.onEscape);
    };
    Modal.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.onEscape);
    };
    Modal.prototype.render = function () {
        var _a = this.props, isOpen = _a.isOpen, header = _a.header, mainActionButton = _a.mainActionButton, secondaryActionButton = _a.secondaryActionButton, cancelText = _a.cancelText, onClose = _a.onClose, tertiaryActionArea = _a.tertiaryActionArea;
        var children = mainActionButton.children, buttonProps = __rest(mainActionButton, ["children"]);
        var secondaryButton;
        if (secondaryActionButton) {
            var secondaryChildren = secondaryActionButton.children, secondaryButtonProps = __rest(secondaryActionButton, ["children"]);
            secondaryButton = React.createElement(Button, __assign({ className: css(styles.button), appearance: "secondary" }, secondaryButtonProps), secondaryChildren);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: css(styles.backdrop), style: { pointerEvents: isOpen ? 'auto' : 'none', display: isOpen ? 'block' : 'none' }, onClick: onClose }),
            React.createElement("div", { className: css(styles.modalWrapper), style: { display: isOpen ? 'flex' : 'none' } },
                React.createElement("div", { className: css(styles.closeIcon), color: COLORS.grays.light, onClick: onClose },
                    React.createElement(Cross, null)),
                React.createElement("div", { className: css(styles.header) },
                    React.createElement("h4", { className: css(styles.h4) }, header)),
                React.createElement("div", { className: css(styles.content) }, this.props.children),
                React.createElement("div", { style: footerStyles() },
                    tertiaryActionArea ? React.createElement("div", { className: css(styles.tertiaryArea) }, tertiaryActionArea) : null,
                    cancelText ? (React.createElement(Button, { className: css(styles.button), appearance: "secondary", onClick: onClose }, cancelText)) : null,
                    secondaryButton,
                    React.createElement(Button, __assign({ className: css(styles.button) }, buttonProps), children)))));
    };
    return Modal;
}(React.Component));
export { Modal };
var styles = StyleSheet.create({
    header: {
        display: 'block',
        height: '25px',
        borderBottom: "solid 1px " + COLORS.grays.cardBorder,
        padding: PADDING.small + " " + PADDING.default,
    },
    content: {
        display: 'block',
        overflowY: 'auto',
        padding: PADDING.tiny + " " + PADDING.default + " " + PADDING.small + " " + PADDING.default,
    },
    closeIcon: {
        position: 'absolute',
        top: '30px',
        right: '32px',
        cursor: 'pointer',
    },
    tertiaryArea: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
    },
    h4: {
        width: 'auto',
        height: '28px',
        fontFamily: 'Lato',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 1.56,
        letterSpacing: 'normal',
        color: '#212b36',
        margin: 0,
        padding: 0
    },
    button: {
        marginLeft: '16px',
    },
    backdrop: {
        position: 'fixed',
        pointerEvents: 'auto',
        top: '0px',
        bottom: '0px',
        left: '0px',
        right: '0px',
        background: 'rgba(0, 0, 0, 0.45)',
        zIndex: 2147483646,
    },
    modalWrapper: {
        position: 'fixed',
        left: '50%',
        maxHeight: '100vh',
        flexDirection: 'column',
        background: COLORS.white,
        zIndex: 2147483647,
        borderRadius: BORDER_RADIUS.large,
        top: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '576px',
    }
});
